var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-wrap"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/logo@2x.webp")}}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.appTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }